var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:({
		html:true,
		title:_vm.text,
		interactive:false,
		variant: _vm.variant,
		placement: _vm.placement,
	}),expression:"{\n\t\thtml:true,\n\t\ttitle:text,\n\t\tinteractive:false,\n\t\tvariant,\n\t\tplacement,\n\t}",modifiers:{"hover":true}}],class:("text-" + _vm.variant),style:(_vm.iconStyle),attrs:{"name":"mdi.information"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }